import React, { useContext, useEffect, useRef, useState } from 'react'
import { LoginContext } from '../../../contexts/login.context'
import { Controller, FieldValues, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Link } from 'react-router-dom'
import Loader from '../../../components/loader'
import { ApiServiceContext, end_points } from '../../../services/core.index'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import loginLogo from '../../../assetsSass/img/login-logo.svg'

import loginImg from '../../../assetsSass/img/login-img.svg'

const LoginComponent = () => {
  const dispatch = useDispatch()
  const layoutsettings = useSelector((state: any) => state?.layoutsettings)
  const { getData } = useContext(ApiServiceContext)
  const [passwordType, setPasswordType] = useState('password')
  const {
    submitLoginForm,
    loginFormSchema,
    errorMessage,
    loading,
    setdeviceInfo,
  } = useContext<any>(LoginContext)

  const defaultValues = {
    userName: DEV_MODE == 'development' ? 'Cameronjacop' : '',
    password: DEV_MODE == 'development' ? 'Cameron@99' : '',
  }

  const {
    handleSubmit: loginFormAction,
    control: loginFormControl,
    setValue: loginFormSetValue,
    formState: { errors: loginFormErrors },
    clearErrors,
  } = useForm({
    resolver: yupResolver(loginFormSchema),
    defaultValues: {
      ...defaultValues,
      rememberMe: false,
    },
  })

  const setDeviceinfos = async () => {
    let OSName = 'Unknown OS'
    const nAgt = navigator.userAgent
    let browserName = navigator.appName
    let nameOffset, verOffset

    // In Opera, the true version is after "OPR" or after "Version"
    if ((verOffset = nAgt.indexOf('OPR')) != -1) {
      browserName = 'Opera'
    }
    // In MS Edge, the true version is after "Edg" in userAgent
    else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
      browserName = 'Microsoft Edge'
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer'
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome'
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari'
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox'
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset)
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName
      }
    }

    if (navigator.platform.indexOf('Win') != -1) OSName = 'Windows'
    if (navigator.platform.indexOf('Mac') != -1) OSName = 'MacOS'
    if (navigator.platform.indexOf('X11') != -1) OSName = 'UNIX'
    if (navigator.platform.indexOf('Linux') != -1) OSName = 'Linux'

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setdeviceInfo({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        })
      })
    }

    setdeviceInfo((prevState: any) => {
      return {
        ...prevState,
        browserName: browserName,
        OSName: OSName,
      }
    })
  }

  useEffect(() => {
    setDeviceinfos()
    // setLayoutdetails()
  }, [])

  useEffect(() => {
    const loginWrapper: any = document.querySelector('.login-wrapper')
    if (loginWrapper) {
      loginWrapper.style.backgroundImage = `url('${layoutsettings.login_background_image}')`
    }
  }, [layoutsettings])

  return (
    <>
      <div className='main-wrapper login-wrapper'>
        <div className='log-wrapper login-lft'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <img src={loginImg} alt='login-img' className='login-lft-img' />
                <div className='login-content'>
                  <a href='#.'>
                    <FontAwesomeIcon icon={faChevronLeft} /> Back to Website
                  </a>
                  <h1>“The Best Way to Get Where You’re Going”</h1>
                  <p>Let us help you with your next freight quote.</p>
                  <a href='#.' className='driver-login'>
                    Swift to Driver ? Fleet Manager Login?
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='log-wrapper login-rht'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <div className='login-form d-block'>
                  <img src={loginLogo} alt='logo' />
                  <div className='login-form-inner'>
                    <h2 className='text-center text-uppercase'>Login</h2>
                    <p className='mt-2'>
                      Enter Below Details to Continue Login
                    </p>
                    <div className='cc-login-form text-start'>
                      <form onSubmit={loginFormAction(submitLoginForm)}>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleInputemail1'
                            className='form-label'
                          >
                            User Name
                          </label>
                          <Controller
                            name='userName'
                            control={loginFormControl}
                            render={({ field: { value, onChange } }) => (
                              <div>
                                <input
                                  value={value || ''}
                                  onChange={onChange}
                                  type='userName'
                                  placeholder='Enter User Name'
                                  className={`form-control ${
                                    loginFormErrors.userName
                                      ? 'border border-danger'
                                      : ''
                                  }`}
                                />
                              </div>
                            )}
                          />
                          {/* <input type="email" className="form-control" id="exampleInputemail1" aria-describedby="" placeholder="Enter email Address" /> */}
                        </div>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleInputPassword1'
                            className='form-label'
                          >
                            Password
                          </label>
                          <Controller
                            name='password'
                            control={loginFormControl}
                            render={({ field: { value, onChange } }) => (
                              <input
                                value={value || ''}
                                onChange={onChange}
                                autoComplete='false'
                                placeholder='Enter Password'
                                type={passwordType}
                                className={`form-control pass-input ${
                                  loginFormErrors?.password
                                    ? 'border border-danger'
                                    : ''
                                }`}
                              />
                            )}
                          />
                          {/* <input type="password" className="form-control" id="exampleInputPassword1" placeholder="Enter Password" /> */}
                        </div>
                        <button
                          type='submit'
                          className='btn login-btn menu btn-hvr w-100'
                        >
                          Login
                        </button>
                      </form>
                      <div className='forgot-user'>
                        <Link
                          to='/auth/forgot-password'
                          className='login-fgt link-hvr'
                        >
                          Forgot Password?
                        </Link>
                        <a href='#.' className='login-driver'>
                          Driver / Fleet Manager Login?
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoginComponent
